// Modern mobile device indicators
const MOBILE_REGEX =
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
/**
 * Determines if the current user agent indicates a mobile device.
 * @returns {boolean} True if this is a mobile device, false otherwise.
 */
const isMobileDevice = (): boolean => {
  // Check for browser environment
  if (typeof navigator === 'undefined') {
    return false;
  }

  const userAgent: string = navigator.userAgent || '';

  return MOBILE_REGEX.test(userAgent);
};

const getPlatformType = (
  isInAppBrowser: boolean,
  isMobileApp: boolean
): 'in_app_browser' | 'mobile_app' | 'mobile_web' | 'desktop_web' => {
  if (isInAppBrowser) {
    return 'in_app_browser';
  }

  if (isMobileApp) {
    return 'mobile_app';
  }

  if (isMobileDevice()) {
    return 'mobile_web';
  }

  return 'desktop_web';
};

export default getPlatformType;
